import React from "react";
import {
  CardContainer,
  TitleContainer,
  TextContainer,
} from "./styled-components";
import Text from "../text";
import { ReactComponent as LightIcon } from "../../assets/icons/light.svg";

const AdviceCard = () => {
  return (
    <CardContainer>
      <TitleContainer>
        <LightIcon />
        <Text size="18px" weight={700}>
          Nos conseils pour créer votre dossier
        </Text>
      </TitleContainer>
      <TextContainer>
        <Text>
          Si vous souhaitez saisir le Défenseur des droits, il faut expliquer
          votre situation en détail à nos juristes.
        </Text>

        <Text>
          Transmettez-nous les documents ou les échanges avec l’organisme ou la
          personne avec qui vous avez un problème.
        </Text>
        <Text>Par exemple :</Text>
        <ul>
          <li>
            <Text weight={700}>
              la copie de vos échanges avec l'organisme ou la personne
            </Text>
          </li>
          <li>
            <Text weight={700}>la copie de la décision de justice </Text>
          </li>
        </ul>
      </TextContainer>
    </CardContainer>
  );
};

export default AdviceCard;
